/**
 * useScheduleDraftMutationHelper — ScheduleDraft mutation 缓存失效辅助层。
 *
 * 本 hook 统一封装 mutation 成功后的 query invalidation 与调用方 onSuccess
 * 顺序，避免各个写操作重复拼接 React Query 选项。它只处理缓存生命周期，
 * 不处理业务 payload 或 UI 提示。
 *
 * 设计文档 → docs/20_workspace_ux/28_frontend_code_map_and_data_flow.md
 * 骨架关联 → hooks/queryKeys.js (缓存 key), hooks/useScheduleDraftFlightMutations.js (航班 mutation), hooks/useScheduleDraftTrackMutations.js (轨 mutation)
 */

import { useQueryClient } from "react-query";

export function useScheduleDraftMutationHelper(options = {}) {
    const queryClient = useQueryClient();

    return {
        buildMutationOptions(extraOptions = {}) {
            const mergedOptions = { ...options, ...extraOptions };
            const { invalidateQueryKeys = [], onSuccess, ...restOptions } = mergedOptions;
            return {
                ...restOptions,
                onSuccess: async (...args) => {
                    await Promise.all(
                        invalidateQueryKeys
                            .filter(Boolean)
                            .map((queryKey) => queryClient.invalidateQueries(queryKey)),
                    );
                    if (onSuccess) {
                        await onSuccess(...args);
                    }
                },
            };
        },
    };
}

export default useScheduleDraftMutationHelper;
